import { Link, useHistory, useLocation } from 'react-router-dom';
import { UrbainHeaderProps, UrbainSocialLink } from './types';
import './UrbainHeaderStyles.scss';
import { useEffect } from 'react';
import { useState } from 'react';
import NavBarUser from '../NavBarUser/NavBarUser';
const fixedPages = [
  '/covid',
  '/about-us',
  '/city-guide/',
  '/explorers-journal',
  '/live-like-a-local/',
  '/terms-of-use',
  '/privacy-notice',
  '/cookie-policy'
];

const fixedDefaultHeader = ['/list-your-home-urbain'];

const noHeaderPages = ['/interhome-successful-payment/', '/interhome-retry-payment'];

function UrbainHeader({ fb, linkedIn, twitter }: UrbainHeaderProps) {
  const history = useHistory();
  const { pathname } = useLocation();
  const [isScrolled, setIsScrolled] = useState(window.scrollY > 10);
  const [shouldBeFixed, setShouldBeFixed] = useState(true);
  const [shouldBeFixedDefaultHeader, setShouldBeFixedDefaultHeader] = useState(false); // Fixes the default header (white background)
  const [showHeader, setShowHeader] = useState(true);

  useEffect(() => {
    setShouldBeFixed(pathname === '/' || fixedPages.some(pageName => pathname.startsWith(pageName)));
    setShouldBeFixedDefaultHeader(fixedDefaultHeader.some(pageName => pathname.startsWith(pageName)));
    setShowHeader(!noHeaderPages.some(pageName => pathname.startsWith(pageName)));
  }, [pathname]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function handleScroll() {
    if (window.scrollY > 10) {
      setIsScrolled(true);
    }
    if (window.scrollY <= 10) {
      setIsScrolled(false);
    }
  }

  const socialLinks: Array<UrbainSocialLink> = [];
  if (fb) {
    socialLinks.push({
      to: 'https://www.facebook.com/stayurbain',
      icon: <i data-test="fa" className="fab fa-facebook-square" />
    });
  }
  if (linkedIn) {
    socialLinks.push({
      to: 'https://www.linkedin.com/company/stay-urbain',
      icon: <i data-test="fa" className="fab fa-linkedin" />
    });
  }
  if (twitter) {
    socialLinks.push({
      to: 'https://www.instagram.com/stayurbain',
      icon: <i data-test="fa" className="fab fa-instagram" />
    });
  }

  return (
    <>
      {showHeader ? (
        <header
          className={`header ${isScrolled || !shouldBeFixed ? 'scrolled-shadow' : ''} ${
            !shouldBeFixed && !shouldBeFixedDefaultHeader ? 'should-not-be-fixed' : ''
          }`}
        >
          <div className={`header-outer ${isScrolled || !shouldBeFixed ? 'white-background' : ''}`}>
            <div className="header-inner">
              <div className={`controls ${isScrolled || !shouldBeFixed ? 'scrolled-height' : ''}`}>
                <div className="controls-left col-4 d-none d-md-flex px-0">
                  <div className="social flex">
                    {socialLinks.map((social: UrbainSocialLink, index: number) => (
                      <div className="social-icon" key={index.toString()}>
                        <a href={social.to} target={'_blank'} rel="noreferrer">
                          {social.icon}
                        </a>
                      </div>
                    ))}
                  </div>
                  <div className="highlight">
                    <Link to="/about-us">About Us</Link>
                  </div>
                  <div className="highlight">
                    <Link to="/explorers-journal">Explorer's Journal</Link>
                  </div>
                </div>
                <div className="controls-center col-4" onClick={() => history.push('/')}>
                  {isScrolled || !shouldBeFixed ? (
                    <div className="logo-img-container logo-small"></div>
                  ) : (
                    <>
                      <div className="col-12 col-md-6 logo-img-container main-logo-img"></div>
                      <div className="logo-text d-none d-md-block">Stay Delighted</div>
                    </>
                  )}
                </div>
                <div className="controls-right col-8 col-md-4 px-0">
                  <div className="highlight d-none d-md-block">
                    <Link to="/list-your-home-urbain">List your home on Urbain</Link>
                  </div>
                  <NavBarUser />
                </div>
              </div>
            </div>
          </div>
        </header>
      ) : (
        ''
      )}
    </>
  );
}

export default UrbainHeader;
